<tm-modal [title]="title" [message]="message" [okBtnLabel]="okBtnLabel" [cancelBtnLabel]="cancelBtnLabel"
  [panelClass]="panelClass" [modalConfig]="modalConfig"
  (afterConfirm)="afterConfirm.emit()" (afterCancel)="afterCancel.emit()">
  <tm-modal-header></tm-modal-header>
  <tm-modal-body>
    <div #tmModalBody>
      <p [innerHTML]="safeMessage" style="white-space: pre-line;" #tmModalBody #tip></p>
      <button type="button" *ngIf="showCopyButton" (click)="copyTip(tip)">{{copyBtnLabel}}</button>
    </div>
  </tm-modal-body>
  <tm-modal-footer></tm-modal-footer>
</tm-modal>
